"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importDefault(require("react"));
const ui_library_1 = require("@hum/ui-library");
const Checkbox = ({ name, label, value, className, onChange }) => {
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(ui_library_1.Text, { type: ui_library_1.TextType.LABEL },
            react_1.default.createElement("input", { className: "ml-5 mr-2.5 border-2 border-borderColor rounded-sm ", id: name, name: name, type: "checkbox", onChange: (e) => onChange(e.currentTarget.checked), checked: value }),
            label)));
};
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map